
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useTranslation } from "react-i18next";

interface ProvidersSortingProps {
  sortOption: string;
  setSortOption: (option: string) => void;
  filteredProvidersCount: number;
  loading: boolean;
}

const ProvidersSorting = ({
  sortOption,
  setSortOption,
  filteredProvidersCount,
  loading
}: ProvidersSortingProps) => {
  const { t } = useTranslation('explore');

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
      <p className="text-brand-slate">
        {loading ? t("providers.loading") : 
          `${filteredProvidersCount} ${filteredProvidersCount === 1 ? "provider" : "providers"} found`
        }
      </p>
      
      <div className="flex items-center gap-3">
        <Select value={sortOption} onValueChange={setSortOption}>
          <SelectTrigger className="w-[180px] border-brand-cloud bg-white text-brand-ink">
            <SelectValue placeholder={t("sortBy")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="featured">{t("sortOptions.featured")}</SelectItem>
            <SelectItem value="rating">{t("sortOptions.rating")}</SelectItem>
            <SelectItem value="reviews">{t("sortOptions.reviews")}</SelectItem>
            <SelectItem value="name_asc">{t("sortOptions.nameAsc")}</SelectItem>
            <SelectItem value="name_desc">{t("sortOptions.nameDesc")}</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default ProvidersSorting;
